import React from 'react';
import { VoucherNew as VoucherNewScreen } from '@features/voucher-new';

export const VoucherNew = (props: any) => <VoucherNewScreen {...props} />;
